import { RESET_STATE } from '../auth/constants';
import { SPRAY_EVENT_TYPE_SET, SPRAY_EVENT_TYPE_CROP } from './constants';

import { ResetStateAction } from '../auth/types';
import { SprayEventTypeState, SetSprayEventTypeAction } from './types';

const initialState = SPRAY_EVENT_TYPE_CROP;

export default function reducer(
    state: SprayEventTypeState = initialState,
    action: SetSprayEventTypeAction | ResetStateAction
): SprayEventTypeState {
    switch (action.type) {
        case SPRAY_EVENT_TYPE_SET:
            return action.payload;
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
